
import '@/assets/scss/index.scss'

// import ScrMbc0113 from '@/pages/ds/dsa/SCR_MBC_0113.vue'
import { commonfunc } from '~/mixin/common'

import DaisoImage from '~/components/common/DaisoImage.vue'

export default {
  components: {
    DaisoImage,
  //  ScrMbc0113
  },
  mixins: [commonfunc],
  data () {
    return {
      outerVisible: false,
      atchFileUrl: ''
    }
  },
  watch: {
    outerVisible (data) {
      if (!data) {
        document.getElementsByClassName('el-dialog__body')[2].scrollTo({ top: 0, left: 0 }) // 스크롤 초기화
      }
    }
  },
  mounted () {
  },
  methods: {
    sel () {
      try {
        this.$AxiosBuilder
          .data()
          .build()
          .post('/ds/exh/selFooterBuySafeSvc')
          .then((res) => {
            const safeSvcData = res.data.data.selBuySafeSvc.filter(({ orglFileExtn }) => {
              return orglFileExtn !== 'pdf'
            })[0]
            this.atchFileUrl = this.imgUrlMaker(safeSvcData.atchFileUrl)
          })
      } catch (e) {
        console.log('첨부파일 목록 조회 중 에러 발생 :>> ', e)
      }
    },
    verChange (param) {
      console.log(param)
      this.selFooterTrmCle(param.agr, param.ver)
    }
  }
}
